exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.styles--onlyXs__I1Bfe{display:none !important}}@media (min-width: 768px){.styles--smUp__1JzZL{display:none !important}}@media (max-width: 999px){.styles--mdDown__1DPWx{display:none !important}}.styles--title__p14Aw{font-size:19px;line-height:25px;max-height:74px}.styles--titleIcon__2Jmf9{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:56px;height:56px;background:#ffeedc}.styles--groupContainer__2e5Zq{border-bottom-width:1px;border-style:solid}.styles--groupContainerWrap__ZP2b9{margin-top:-1px}.styles--groupItem__24Cd6{margin-bottom:-1px !important;border-width:1px;border-style:solid;border-left:none;border-color:#e3e4e8}\n", ""]);

// exports
exports.locals = {
	"onlyXs": "styles--onlyXs__I1Bfe",
	"smUp": "styles--smUp__1JzZL",
	"mdDown": "styles--mdDown__1DPWx",
	"title": "styles--title__p14Aw",
	"titleIcon": "styles--titleIcon__2Jmf9",
	"groupContainer": "styles--groupContainer__2e5Zq",
	"groupContainerWrap": "styles--groupContainerWrap__ZP2b9",
	"groupItem": "styles--groupItem__24Cd6"
};